<template>
	<div class="my-table managementPage">
		<div class="searchBox flexCenter">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t("management.txt1")}}</span>
				<span>{{$t("management.txt2")}} / {{type == 1 ? $t("management.txt3") : $t("management.txt4")}}</span>
			</div>
			<div class="flexEnd">
				<div class="handleBoxSeach flexCenter w350">
					<el-input
					:placeholder="$t('management.txt5')"
					v-model="queryInfo.projectName" @keypress.native.enter="loadData">
					<img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
				</el-input>
				<div class="searchBtn" @click="loadData">{{$t('management.txt6')}}</div>
			</div>
			<div class="searchBtn ml20" @click="handleAdd">{{$t('management.txt7')}}</div>
		</div>
	</div>
	<!-- 面包屑 -->
	<div v-loading="loading">
		<el-row :gutter="50" class="cardContent">
			<el-col :span="type == 1?24:7" class="cardBox" v-for="item in dataList" :key="item.id">
				<div class="header">
					<div class="projectName" @click="goDetail(item.id)">{{item.projectName}}</div>
					<div class="controlBtn" v-if="type == 1">
						<!-- <img @click="handleEdit(item)" src="@/assets/picture/icon/edit_icon.png" /> -->
					<!-- 	<img @click="handleDelete(item)" src="@/assets/picture/icon/delete_S_icon.png" /> -->
					</div>
				</div>
				<div class="contentBox" @click="goDetail(item.id)">
					<p>
						<span class="labelTxt fl">{{$t('management.txt8')}}</span>
						<span class="txt fl">{{checkIsMe(item.admin.id, item.admin.userName)}}</span>
					</p>
					<p>
						<span class="labelTxt fl">{{type == 1?$t('management.txt9'):$t('management.txt10')}}</span>
						<span class="txt flexStart userNameTxt">
							<span v-for="(user,index) in item.userInfos"
							:key="index" class="userNameTxt">{{user.userName}}{{index>item.userInfos.length-2?'':','}}</span>
						</span>
					</p>
						<p class="txt fs14">
							{{$t('management.txt11')}}{{checkIsMe(item.admin.id, item.admin.userName)}}{{$t('management.txt12')}}:{{formatDate(item.createTime)}}
						</p>
					</div>
				</el-col>
				<div class="no-data" v-if="dataList.length == 0">{{$t('management.txt13')}}</div>
			</el-row>
		</div>
		<pagination style="text-align: right;" :total="total" :page.sync="queryInfo.pageNum"
			:limit.sync="queryInfo.size" @pagination="loadData" />
			<edit :visible.sync="dialogFormAddVisible" :isEdit="isEdit" :addProjectInfo.sync="addProjectInfo"
			@success="loadData"></edit>
		</div>
	</template>

	<script>
		import { formatDate } from "@/plugins/date.js";
		import edit from "./components/edit";
		import pagination from "../../common/pagination";
		import qs from "qs";
		export default {
			components: {
				pagination,
				edit,
			},
			data() {
		const type = this.$route.path == "/joinProject"?2 : 1; // 1: 管理的 2：加入的
		return {
			type,
			dialogFormAddVisible: false, //新增项目弹窗
			isEdit: false,
			addProjectInfo: {
				projectName: "",
			},
			//用于获取数据列表
			queryInfo: {
				// id: localStorage.roleId,
				me: type,
				projectName: "",
				pageNum: 1,
				size: 10,
			},
			dataList: [],
			total: 0,
			loading: false,
		};
	},
	watch: {
		$route(route) {
			this.type =  this.$route.path == "/joinProject"?2 : 1;
			this.queryInfo.me = this.type;
			this.loadData();
		},
	},
	created() {
		this.loadData();
	},
	methods: {
		checkIsMe(id, text) {
			return text + (id == localStorage.roleId ? " " : "");
		},
		formatDate(time) {
			var date = new Date(time);
			return formatDate(date, "yyyy-MM-dd hh:mm:ss");
		},
		// 数据加载(项目列表)
		async loadData() {
			this.loading = true;
			const { data: res } = await this.$http.post(
				"/project/list?" + qs.stringify({
					...this.queryInfo,
					pageNum: this.queryInfo.pageNum - 1,
				})
				);
			this.$nextTick(() => {
				this.loading = false;
			});
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.dataList = res.result.data;
			this.total = res.result.total;
		},
		// 跳转到详情
		goDetail(id) {
			this.$router.push("/managementProjectDetail?id=" + id);
		},
		// 新建项目
		handleAdd() {
			this.isEdit = false;
			this.dialogFormAddVisible = true;
		},
		// 编辑项目
		handleEdit(item) {
			const data = JSON.parse(JSON.stringify(item));
			data.userInfos = data.userInfos.map((item) => item.id);
			this.addProjectInfo = data;
			this.isEdit = true;
			this.dialogFormAddVisible = true;
		},
		// 搜索
		handleSearch() {
			this.queryInfo.pageNum = 1;
			this.queryInfo.size = 10;
			this.loadData();
		},
		// 编辑/详情
		handleDetail(row, type) {
			this.$router.push({
				path: "/sceneRecordDetail",
				query: {
					type: type,
					id: row.id,
				},
			});
		},
		// 页面切换
		handleCurrentChange(pageNum) {
			this.queryInfo.pageNum = pageNum;
			this.loadData();
		},
		handleSizeChange(pageSize) {
			this.queryInfo.size = pageSize;
			this.loadData();
		},
		// 新建项目
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.addProject();
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		// 取消新建项目
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		// 项目添加
		async addProject() {
			const { data: res } = await this.$http.post(
				"/project/list",
				this.addProjectInfo
				);
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.loadData();
			this.dialogFormAddVisible = false;
		},
	},
};
</script>

<style lang="less" scoped>
	.no-data{
		width: 100%;
		text-align: center;
		color: #999;
		padding-top: 40px;
	}
	.managementPage {
		.userNameTxt{
			font-size: 1.4rem;
    		font-weight: 400;
    		color: #222222;
		}
		.w32 {
			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}
		}
		.fs14{
			font-size: 14px;
		}
		.searchSubBox {
			.el-input {
				width: auto;
				margin-right: 2rem;
			}
		}

		.searchBox {
			/*width: 33.6rem !important;*/
			height: 3.2rem;

			.btnC {
				padding: 0.6rem 2.6rem;
			}
		}
		/deep/ .el-transfer__button:first-of-type {
			display: none;
		}

		/deep/ .el-button--primary {
			width: auto;
			height: auto;
			padding: 0;
			background: none;
		}

		/deep/ .el-button--primary.is-disabled {
			background: none;
			border: none;
		}

		/deep/ .el-button + .el-button {
			margin-left: 0 !important;
		}

		/deep/ .el-transfer__buttons {
			padding: 0;
		}

		.tips {
			font-size: 1.4rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #98b9ff;
			margin-top: -10px;
		}

		/deep/ .el-dialog {
			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}

			/deep/ .el-select {
				width: 100%;
			}

			/deep/ .el-dialog .el-dialog__body .el-select .el-input__inner,
			.el-dialog .el-dialog__body .el-input__inner,
			.el-dialog .el-dialog__body .el-input {
				border-radius: 8px;
			}
		}

		.cardContent {
			width: 100%;
			margin-top: 1.6rem;
			margin-left: 0 !important;

			.cardBox {
				padding:3rem !important; 
				background: #fff;
				border-radius: 3rem;
				margin-bottom: 3rem;
				margin-right: 5%;
				box-sizing: border-box;
				cursor: pointer;
				.header {
					border-bottom: 1px solid #EBEEF3;
					/*padding-bottom: 2rem;*/
					position: relative;
					.controlBtn{
						position: absolute;
						top: 0;
						right: 10px;
						z-index: 9;
					}
					.projectName {
						font-size: 1.4rem;
						font-weight: 400;
						color: #333333;
						cursor: pointer;
						width: 70%;
						height: 100%;
						margin-bottom: 2rem;
					}

					img {
						width: 1.4rem;
						height: 1.8rem;
						margin-right: 2rem;
						cursor: pointer;
					}

					img:last-of-type {
						margin-right: 0;
					}
				}

				.contentBox {
					padding-top: 2.9rem;

					p:first-of-type {
						margin-bottom: 2.5rem;
					}

					p:nth-of-type(2) {
						margin-bottom: 2rem;
					}

					p {
						font-size: 1.2rem;
						font-weight: 400;
						color: #999999;
						overflow: hidden;

						span {
							color: #666;
						}
					}

					.w19 {
						width: 19%;
					}

					.labelTxt {
						font-size: 1.4rem;
						flex: none;
						margin-right: 1.4rem;
						font-weight: 400;
						color: #999999;
					}

					.txt {
						font-size: 1.4rem;
						font-weight: 400;
						color: #222222;
						line-height: 2rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;

						span {
							margin-right: 10px;
						}
					}
				}
			}
			.cardBox:nth-of-type(3n) {
				margin-right: 0;
			}
		}
	}
</style>
